const primaryMain = '#0067B1';
const primaryMainOpacity = 'rgba(0, 103, 177, 0.9)';
const secondaryMain = '#FE7311';
const secondaryMainOpacity = 'rgba(254, 115, 17, 0.5)';
const secondaryLight = '#00447C';
const tertiaryMain = '#001F4E';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
